import { compose, test, toLower } from 'ramda';

const extract = (str, pattern) => (str.match(pattern) || []).pop() || '';

export const extractAlphaAndSpecial = str => extract(str, '[-_a-zA-Z0-9]+');

export const domainValidation = str => extract(str, '[-._a-z0-9]+');

export const limitLength = (str, length) => str.substring(0, length);

export const isEmail = compose(
  test(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  ),
  toLower,
);

export const defaultDomain = '.555platform.com';
